<template src="./template.html"></template>
<script>
import moment from 'moment'
import _find from 'lodash/find'
import _extend from 'lodash/extend'
import _groupBy from 'lodash/groupBy'
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import { mapState } from 'vuex'

import eventService from 'api/event'
import dateUtils from 'utils/dateUtils'
import domUtils from 'utils/domUtils'
import venueService from 'api/venue'

export default {
  name: 'event-calendar',
  props: {
    venueId: {
      type: String,
      required: true,
    },
    onEventClick: {
      type: Function,
    },
    theme: {
      type: String,
      default: 'theme-light',
    },
  },
  computed: {
    ...mapState({
      venue: (state) => state.venue.current,
    }),
  },
  components: {
    FullCalendar,
  },
  data() {
    return {
      events: null,
      calendarOptions: {
        plugins: [dayGridPlugin, interactionPlugin],
        initialView: 'dayGridMonth',
        events: [],
        datesSet: (dateInfo) => {
          const dateStart = dateInfo.start
          const dateEnd = dateInfo.end

          this.getEvents(dateStart, dateEnd)
        },
        eventDisplay: 'block',
        eventDidMount: (eventInfo) => {
          const $el = eventInfo.el
          const event = eventInfo.event
          const eventProps = event.extendedProps || {}

          if (eventProps.image) {
            $el.style['background-image'] = `url("${eventProps.image}")`
          }

          domUtils.addClass($el, `event-index-${eventProps.eventIndex}`)
          domUtils.addClass($el, `events-${eventProps.eventCount}`)
        },
        eventClick: (eventInfo) => {
          const event = eventInfo.event
          const eventProps = event.extendedProps || {}

          const foundEvent = _find(this.events, {
            id: eventProps.id,
          })

          this.$emit('eventClicked', foundEvent)
        },
      },
      loading: false,
    }
  },
  methods: {
    getEvents(dateStart, dateEnd) {
      this.loading = true

      eventService
        .listByVenueId(this.venueId, {
          dateStart: dateUtils.toUTCTimestampWithoutTime(dateStart),
          dateEnd: dateUtils.toUTCTimestampWithoutTime(dateEnd),
          sort: 'date dateStart',
          limit: 50,
        })
        .then((result) => {
          this.loading = false

          this.events = result.data

          this.calendarOptions.events = this.events.map((event) => {
            return _extend(event, {
              id: event.id,
              title: event.name,
              date: event.date && event.date.toISOString ? event.date.toISOString() : event.date,
              start: event.dateStart && event.dateStart.toISOString ? event.dateStart.toISOString() : event.dateStart,
              addDay: true,
              extendedProps: {
                id: event.id,
                image: event.primaryImage ? event.primaryImage.small : null,
                seoPathname: event.seoPathname,
              },
            })
          })

          const eventGroups = _groupBy(this.events, 'date')

          let finalEvents = []

          Object.keys(eventGroups).forEach((key) => {
            const groupEvents = eventGroups[key]

            groupEvents.forEach((event, index) => {
              event.extendedProps.eventIndex = index
              event.extendedProps.eventCount = groupEvents.length
            })

            finalEvents = finalEvents.concat(groupEvents)
          })

          this.events = finalEvents
        })
        .catch(() => {
          this.loading = false
        })
    },
    getVenue() {
      return venueService
        .getById(this.venueId)
        .then((result) => {
          this.$store.dispatch('setCurrentVenue', result.data)

          this.calendarOptions.validRange = {
            end: moment()
              .add(result.data.inventoryTimeframe || 0, 'days')
              .format('YYYY-MM-DD'),
          }
        })
        .catch((error) => {
          this.$store.dispatch('addTopBarNotification', {
            text: error.message,
          })
        })
    },
  },
  mounted() {
    return this.getVenue()
  },
  updated() {
    this.$emit('updated')
  },
}
</script>



// WEBPACK FOOTER //
// src/components/EventCalendar/index.vue